const pagegrowlerFrontendApiUrl = process.env.PAGEGROWLER_FRONTEND_API ?? process.env.NEXT_PUBLIC_PAGEGROWLER_FRONTEND_API;

export const getDataByFetch = async (url,flag = false, encoding = false, authorization = false) => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Content-Type", "application/json");
        if(!!encoding) myHeaders.append("Accept-Encoding", encoding);
        if(!!authorization) myHeaders.append("Authorization", authorization);
        const response = await fetch(`${url}`, {
            method: 'GET',
            headers: myHeaders,
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if(!flag){
            const { items = [] } = data.item || data;
            return items;
        } else {            
            return data;
        }
        
    } catch (error) {
        return false;
    }
}

export const getPingByFetch = async (url) => {
    try {
        const response = await fetch(`${url}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        });
        const data = await response.json(); 
        return data;
        
    } catch (error) {
        return {
            ping: "error",
            error: error.message
        };
    }
}

export const getBucketsHeaders = async (flag = false) => {
   
    const urls = {
        //opinion: `${url_base}contents/v1/detail/opinion?type=bucket&field=slug`,
        opinion: `${pagegrowlerFrontendApiUrl}opinion?type=bucket&field=slug`,
        //liveblogs: `${url_base}contents/v1/detail/lieveblogs-lx?type=bucket&field=slug`,
        liveblogs: `${pagegrowlerFrontendApiUrl}lieveblogs-lx?type=bucket&field=slug`,
        //ultimomento: `${url_base}contents/v1/latest/?type=lilanews&section=10260&limit=12`,
        ultimomento: `${pagegrowlerFrontendApiUrl}lilanews?type=listType&sectionUrl=ultimo-momento&limit=12`,
        //urgent: `${process.env.LILAX_FRONTEND_API}menus/urgente`,
        urgent: `${pagegrowlerFrontendApiUrl}menu?slug=urgente`,
    };
    const [opinion, liveblogs, ultimomento, urgent] = await Promise.all([
        (flag == true) ? getDataByFetch(`${urls.opinion}`, true) : new Promise((resolve) => resolve(false)),
        getDataByFetch(`${urls.liveblogs}`, true),
        (flag == true) ? getDataByFetch(`${urls.ultimomento}`, true) : new Promise((resolve) => resolve(false)),
        getDataByFetch(`${urls.urgent}`, true),
    ]);    
    return {
        opinion,
        liveblogs,
        ultimomento,
        urgent,
    }
}

export const getBucketById = async (idBucket) => {
    const content = await getDataByFetch(`${pagegrowlerFrontendApiUrl}${idBucket}?type=bucket`, true);
    return content?.content ?? [];
}

export const getBucketBySlug = async (slug) => {
    const content = await getDataByFetch(`${pagegrowlerFrontendApiUrl}${slug}?type=bucket&field=slug`, true);
    return content?.content ?? [];
}

export const getBucketByIdFromOle = async (idBucket) => {
    const content = await getDataByFetch(`${process.env.NEXT_PUBLIC_FRONTEND_API_OLE}contents/v1/detail/${idBucket}?type=bucket&field=slug`);
    return content;
}

export const getBucketElleMagazines = async (idBucket) => {
    const content = await getDataByFetch(`http://api.lilax.agea.com.ar/E1S4G4ycq/contents/v1/detail/q7dCRE4N4?type=bucket`);
    return content;
}